
import waxjs from "./wallets/waxjs.js"
import AnchorLinkBrowserTransport from "./wallets/anchor-link-browser-transport"
import AnchorLink from "./wallets/anchor-link"

import type { Connection, SendOptions, Signer, Transaction, TransactionSignature } from '@solana/web3.js';
import { PublicKey } from '@solana/web3.js';
import { phantomProvider } from "./actionsSol.ts";
import binary_to_base58 from "./crypto/binary_to_base58.mjs";
import { phantomAPP } from "./definitions.ts";

  export function getConnectUrl(sessID: string, phantomInfos:phantomAPP, network:string){

      let baseURL = 'https://phantom.app/ul/v1/connect?';

      baseURL += "app_url="+phantomInfos.siteURL;
      baseURL += "&dapp_encryption_public_key="+binary_to_base58(phantomInfos.sharedPK);
      baseURL += "&redirect_link="+phantomInfos.siteURL+'/api/phantomConnect?sessID='+sessID;
      baseURL += "&cluster="+network;

      return baseURL;
  }


  export async function phantomLogin():Promise<string | null>{

      console.log('init phantom ');
      
      let phantomProvider = null;

      if ('phantom' in window) {
        const phantom:phantomProvider = window.phantom as phantomProvider;

        if(phantom !== null){
          const provider = phantom.solana;
          if (provider?.isPhantom) {
            phantomProvider = provider;
          }
        }
      }

      if(!phantomProvider){

          alert('cannot connect phantom wallet');
          return null;
      }

      try {
        

          const resp = await phantomProvider.connect();
          const myAccount = phantomProvider.publicKey.toString();

          console.log(phantomProvider.publicKey.toString());
          console.log(phantomProvider.isConnected);
          console.log(phantomProvider);

          return myAccount;
      } catch (e:any) {
          console.log('error connecting phantom '+e.message);
          return null;
      }
  }



export async function waxlogin(ep:string) {
      console.log('init wcw ');
      
      try {
          const wax = new waxjs.WaxJS({ rpcEndpoint: ep, freeBandwidth: false });
          let isAutoLoginAvailable = await wax.isAutoLoginAvailable();
          const myAccount = isAutoLoginAvailable ? wax.userAccount : await wax.login();
          return myAccount;
      } catch (e: any) {
          alert('wax login error ' + e.message);
          console.log('wax login error ' + e.message);
          return null;
      }
  }

  export async function linkLogin(chainId: string, ep: string) {
      console.log('init anchor ');
      
      try{
        const transport = new AnchorLinkBrowserTransport();
        const link = new AnchorLink({ transport, chains: [{ chainId: chainId, nodeUrl: ep }] });

        const identity = await link.login('crazy cars');
        const myAccount = identity.payload.sa;


        return myAccount;
      }catch (e:any) {
          console.log('error connecting anchor '+e.message);
          return null;
      }
  }

  type SignedMessage = {
    signature:Uint8Array
  }

  export interface BackpackWallet {
    isBackpack?: boolean;
    publicKey?: { toBytes(): Uint8Array };
    isConnected: boolean;
    signTransaction(transaction: Transaction, publicKey?: PublicKey | null): Promise<Transaction>;
    signAllTransactions(transactions: Transaction[], publicKey?: PublicKey | null): Promise<Transaction[]>;
    send(
        transaction: Transaction,
        signers?: Signer[],
        options?: SendOptions,
        connection?: Connection,
        publicKey?: PublicKey | null
    ): Promise<TransactionSignature>;
    signMessage(message: Uint8Array, publicKey?: PublicKey | null): Promise<SignedMessage>;
    connect(): Promise<void>;
    disconnect(): Promise<void>;
}

  export interface BackpackWindow extends Window {
    backpack?: BackpackWallet;
  }

  declare const window: BackpackWindow;

  export async function backpackLogin():Promise<string | null>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const wallet = window.backpack!;

      try {
          await wallet.connect();
      } catch (error: any) {
          console.log(' backpack connection error '+error.message);
          return null;
      }

      if (!wallet.publicKey) {
          console.log(' backpack account error ');
          return null;
      }

      try {
          const publicKey = new PublicKey(wallet.publicKey.toBytes());
          return publicKey.toString();
      } catch (error: any) {
          console.log('unable to login using backpack '+error.message);
          return null;
      }
      //wallet.on('disconnect', this._disconnected);

  }